// packages
import cx from 'classnames';
import { Component, h } from 'preact';

// components
import CandidateRow from './components/CandidateRow';
import Contest from './components/Contest';
import NewContestShowcase from './components/NewContestShowcase';
import YourRaces from './components/YourRaces';
import Portal from './components/Portal';
import Ad from './components/Ad';

import find from './utils/find';
import {
  determineContestTitle,
  chunk,
  lastUpdatedFormat,
} from './election-utils';
import { RESULTS_IN_USE, visibleCandidatesCount } from './endpoints';
import getJSON from './utils/get-json';
import { LENGTH_OF_CHECK_INTERVAL } from './constants';

type State = {
  data: { [key: string]: any };
  now: Date | null;
};

class App extends Component<{}, State> {
  //   timer!: number;

  constructor() {
    super();

    this.state = {
      data: [],
      now: null,
      timer: 0,
    };

    this.fetchData = this.fetchData.bind(this);
  }

  fetchData() {
    const now = new Date();
    console.info('Requesting:', now);

    const asOf = lastUpdatedFormat(now)

    getJSON(RESULTS_IN_USE).then(data =>
      this.setState({ data, asOf }, this.startTimer)
    );
  }

  startTimer() {
    this.timer = window.setTimeout(this.fetchData, LENGTH_OF_CHECK_INTERVAL);
  }

  clearTimer() {
    window.clearTimeout(this.timer);
  }

  componentDidMount() {
    this.fetchData();
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  componentDidUpdate() {
                         // This is for countdown timer, can put back if need be
                         // const length = Math.ceil(LENGTH_OF_CHECK_INTERVAL / 60000);
                         // countdown(length); //where n is the number of minutes required.
                       }

  render() {
    const { flags, annotations } = this.props;
    const { data, asOf } = this.state;


    // In order to sprinkle ads between races in sections where there a lot of races like the Texas House, we need to divide them into groups of nth races to make it into different divs 

    const texasHouse = data
    .filter(contest => contest.office === 'Texas House')

    const usHouse = data
    .filter(contest => contest.office === 'U.S. House')

    let texasHouseGroups, usHouseGroups;

    if (texasHouse.length) {
      texasHouseGroups = chunk(texasHouse, 26)
      usHouseGroups = chunk(usHouse, 24)
    }

    return (
      <div class="results">
        <Portal
          node={document.getElementById('your-races')}
          ref={ref => (this._yourPortal = ref)}
        >
          <YourRaces annotations={annotations} asOf={asOf} contests={data} flags={flags} />
        </Portal>

        <NewContestShowcase
          contest={find(data, contest => contest.office === 'President')}
          container={document.querySelector('#president .president')}
          annotations={annotations.filter(
            item => item.type === 'president'
          )}
          asOf={asOf}
        />
        <NewContestShowcase
          contest={find(data, contest => contest.office === 'U.S. Senate')}
          container={document.querySelector('#us-senate .senate')}
          annotations={annotations.filter(
            item => item.type === 'us-senate-class-2'
          )}
          asOf={asOf}
        />

        <Portal
          node={document.querySelector('#us-house .contests')}
          ref={ref => (this._usPortal = ref)}
        >
          <div class="office__contests">
          {usHouse.length > 0 && (usHouseGroups.map(contestGroup => (
            <div class="contest-group">
            <div class="seat__contests-double">
            {contestGroup.map(contest => (<Contest
                  key={contest.id}
                  contest={contest}
                  flags={flags.filter(
                    item => item.type === contest.office_slug
                  )}
                  annotations={annotations.filter(
                    item => item.type === contest.office_slug
                  )}
                  visibleCandidateCount={visibleCandidatesCount}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  asOf={asOf}
                  tableHeader={CandidateRow.Header}
                  columnCount={CandidateRow.columnCount}
                  renderCandidate={(
                    candidate,
                    idx,
                    viewAllCandidates,
                    { totalVotes }
                  ) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      contestIsCalled={candidate.is_called}
                      isIncumbent={candidate.is_incumbent}
                      isWinner={candidate.is_winner}
                      isViewable={
                        viewAllCandidates || idx < visibleCandidatesCount
                      }
                      party={candidate.party}
                      totalVotesInContest={totalVotes}
                      votes={candidate.votes}
                    />
                  )}
                />
                ))}
                
          </div>
          <Ad />
        </div>
        )))}
          </div>
        </Portal>
        <Portal
          node={document.querySelector(
            '#railroad-commission-of-texas .contests'
          )}
          ref={ref => (this._supremePortal = ref)}
        >
          <div class="office__contests seat__contests-double">
            {data
              .filter(contest => contest.office === 'Texas Railroad Commission')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  flags={flags.filter(
                    item => item.type === contest.office_slug
                  )}
                  annotations={annotations.filter(
                    item => item.type === contest.office_slug
                  )}
                  asOf={asOf}
                  visibleCandidateCount={visibleCandidatesCount}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  columnCount={CandidateRow.columnCount}
                  renderCandidate={(
                    candidate,
                    idx,
                    viewAllCandidates,
                    { totalVotes }
                  ) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      contestIsCalled={candidate.is_called}
                      isIncumbent={candidate.is_incumbent}
                      isWinner={candidate.is_winner}
                      isViewable={
                        viewAllCandidates || idx < visibleCandidatesCount
                      }
                      party={candidate.party}
                      totalVotesInContest={totalVotes}
                      votes={candidate.votes}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>
        <Portal
          node={document.querySelector('#state-board-of-education .contests')}
          ref={ref => (this._sboePortal = ref)}
        >
          <div class="office__contests seat__contests-double">
            {data
              .filter(contest => contest.office === 'State Board of Education')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  flags={flags.filter(
                    item => item.type === contest.office_slug
                  )}
                  annotations={annotations.filter(
                    item => item.type === contest.office_slug
                  )}
                  visibleCandidateCount={visibleCandidatesCount}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  asOf={asOf}
                  tableHeader={CandidateRow.Header}
                  columnCount={CandidateRow.columnCount}
                  renderCandidate={(
                    candidate,
                    idx,
                    viewAllCandidates,
                    { totalVotes }
                  ) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      contestIsCalled={candidate.is_called}
                      isIncumbent={candidate.is_incumbent}
                      isWinner={candidate.is_winner}
                      isViewable={
                        viewAllCandidates || idx < visibleCandidatesCount
                      }
                      party={candidate.party}
                      totalVotesInContest={totalVotes}
                      votes={candidate.votes}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>
        <Portal
          node={document.querySelector('#texas-supreme-court .contests')}
          ref={ref => (this._supremePortal = ref)}
        >
          <div class="office__contests seat__contests-double">
            {data
              .filter(contest => contest.office === 'Texas Supreme Court')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  flags={flags.filter(
                    item => item.type === contest.office_slug
                  )}
                  annotations={annotations.filter(
                    item => item.type === contest.office_slug
                  )}
                  asOf={asOf}
                  visibleCandidateCount={visibleCandidatesCount}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  columnCount={CandidateRow.columnCount}
                  renderCandidate={(
                    candidate,
                    idx,
                    viewAllCandidates,
                    { totalVotes }
                  ) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      contestIsCalled={candidate.is_called}
                      isIncumbent={candidate.is_incumbent}
                      isWinner={candidate.is_winner}
                      isViewable={
                        viewAllCandidates || idx < visibleCandidatesCount
                      }
                      party={candidate.party}
                      totalVotesInContest={totalVotes}
                      votes={candidate.votes}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>
        <Portal
          node={document.querySelector(
            '#texas-court-of-criminal-appeals .contests'
          )}
          ref={ref => (this._crimPortal = ref)}
        >
          <div class="office__contests seat__contests-double">
            {data
              .filter(
                contest => contest.office === 'Texas Court of Criminal Appeals'
              )
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  flags={flags.filter(
                    item => item.type === contest.office_slug
                  )}
                  annotations={annotations.filter(
                    item => item.type === contest.office_slug
                  )}
                  visibleCandidateCount={visibleCandidatesCount}
                  asOf={asOf}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  columnCount={CandidateRow.columnCount}
                  renderCandidate={(
                    candidate,
                    idx,
                    viewAllCandidates,
                    { totalVotes }
                  ) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      contestIsCalled={candidate.is_called}
                      isIncumbent={candidate.is_incumbent}
                      isWinner={candidate.is_winner}
                      isViewable={
                        viewAllCandidates || idx < visibleCandidatesCount
                      }
                      party={candidate.party}
                      totalVotesInContest={totalVotes}
                      votes={candidate.votes}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>
        <Portal
          node={document.querySelector('#texas-senate .contests')}
          ref={ref => (this._senatePortal = ref)}
        >
          <div class="office__contests seat__contests-double">
            {data
              .filter(contest => contest.office === 'Texas Senate')
              .map(contest => (
                <Contest
                  key={contest.id}
                  contest={contest}
                  flags={flags.filter(
                    item => item.type === contest.office_slug
                  )}
                  annotations={annotations.filter(
                    item => item.type === contest.office_slug
                  )}
                  asOf={asOf}
                  visibleCandidateCount={visibleCandidatesCount}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  columnCount={CandidateRow.columnCount}
                  renderCandidate={(
                    candidate,
                    idx,
                    viewAllCandidates,
                    { totalVotes }
                  ) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      contestIsCalled={candidate.is_called}
                      isIncumbent={candidate.is_incumbent}
                      isWinner={candidate.is_winner}
                      isViewable={
                        viewAllCandidates || idx < visibleCandidatesCount
                      }
                      party={candidate.party}
                      totalVotesInContest={totalVotes}
                      votes={candidate.votes}
                    />
                  )}
                />
              ))}
          </div>
        </Portal>
        <Portal
          node={document.querySelector('#texas-house .contests')}
          ref={ref => (this._housePortal = ref)}
        >
          <div class="office__contests">
          {texasHouse.length > 0 && (texasHouseGroups.map(contestGroup => (
            <div class="contest-group">
            <div class="seat__contests-double">
            {contestGroup.map(contest => (<Contest
                  key={contest.id}
                  contest={contest}
                  flags={flags.filter(
                    item => item.type === contest.office_slug
                  )}
                  annotations={annotations.filter(
                    item => item.type === contest.office_slug
                  )}
                  asOf={asOf}
                  visibleCandidateCount={visibleCandidatesCount}
                  columnCount={CandidateRow.columnCount}
                  contestTitle={determineContestTitle(
                    data.filter(
                      item => item.office_slug === contest.office_slug
                    )[0]
                  )}
                  tableHeader={CandidateRow.Header}
                  columnCount={CandidateRow.columnCount}
                  renderCandidate={(
                    candidate,
                    idx,
                    viewAllCandidates,
                    { totalVotes }
                  ) => (
                    <CandidateRow
                      key={candidate.id}
                      ballotName={candidate.name}
                      candidateId={candidate.id}
                      contestIsCalled={candidate.is_called}
                      isIncumbent={candidate.is_incumbent}
                      isWinner={candidate.is_winner}
                      isViewable={
                        viewAllCandidates || idx < visibleCandidatesCount
                      }
                      party={candidate.party}
                      totalVotesInContest={totalVotes}
                      votes={candidate.votes}
                    />
                  )}
                />
                ))}
                
          </div>
          <Ad />
        </div>
        )))}
          </div>
        </Portal>
      </div>
    );
  }
}

export default App;
